<template>
  <v-menu
    v-model="isMenuOpen"
    :close-on-content-click="false"
    :nudge-width="550"
    offset-x
    :max-width="550"
    :z-index="2"
    left
    :nudge-left="0"
  >
    <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
      <v-tooltip bottom :disabled="isTooltipDisabled">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="{ ...attrsMenu, ...attrs }"
            v-on="{ ...onMenu, ...on }"
            color="primaryDark"
            class="mt-2"
            x-small
            width="24"
            min-width="24"
          >
            <v-icon size="16" color="#fff">mdi-tag</v-icon>
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblTag") }}</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-toolbar color="primaryLight1" dark height="40px">
        <v-btn icon large>
          <v-icon size="22" color="primaryDark">mdi-tag-multiple</v-icon>
        </v-btn>
        <v-tooltip bottom v-if="topic.topicName.length > 73">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"  class="text-truncate">
              <strong v-bind="attrs" v-on="on">{{ topic.topicName }}</strong>
            </span>
          </template>
          <span>{{ topic.topicName }}</span>
        </v-tooltip>
        <span  class="text-truncate" v-else>
          <strong>{{ topic.topicName }}</strong>
        </span>
        <v-spacer></v-spacer>
        <CloseIcon @click="isMenuOpen = false" />
      </v-toolbar>

      <v-card-text style="max-height: 300px">
        <span v-if="createTagPermission" style="color: #404040">{{ $t("agenda.msgTag") }} </span>
          <v-combobox
            :key="render"
            :placeholder="$t('agenda.lblTag')"
            class="tag-combobox pt-0 my-2"
            :id="`comboTagId_${topic.agendaId}_${topic.Id}`"
            :ref="`comboTagRef_${topic.agendaId}_${topic.Id}`"
            v-model="tagsArray"
            :items="combinedSuggestions"
            multiple
            chips
            single-line
            :label="$t('agenda.lblTag')"
            solo
            @change="onChangeTags"
            :disabled="!createTagPermission"
            :readonly="!createTagPermission"
            @update:search-input="onSearchInputUpdate"
            @focus="onComboboxFocus"
            @blur="onComboboxBlur"
            @keydown.native="enforceMaxLength"
            :search-input.sync="searchInput"
            :menu-props="{ maxHeight: '200px' }"
            :loading="isSearching"
          >
          <template v-slot:item="{ item }">
            <v-list-item @click.stop="selectSuggestion(item)" class="cursor-pointer">
              <v-list-item-icon>
                <v-icon small>mdi-tag</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:no-data>
            <div class="px-4 py-2 text-center text--secondary" v-if="searchInput && searchInput.trim() && combinedSuggestions.length === 0 && !isSearching">
              {{ $t("agenda.msgNoMatchingTagsFound") }}
            </div>
            <div class="px-4 py-2 text-center text--secondary" v-else-if="isSearching">
              {{ $t("agenda.msgSearchingTags") }}
            </div>
          </template>
          <template v-slot:selection="data">
            <v-tooltip bottom v-if="data.item.length > 55" :max-width="650">
              <template v-slot:activator="{ on }">
                <a-chip
                  v-on="on"
                  small
                  outlined
                  label
                  class="tagChip"
                  color="secondary darken-4"
                  :key="JSON.stringify(data.item)"
                  v-bind="data.item.attrs"
                  :close="createTagPermission"
                  @click:close="
                    createTagPermission ? data.parent.selectItem(data.item) : ''
                  "
                >
                  <strong>#</strong> {{ data.item.slice(0, 53) + "..." }}
                </a-chip>
              </template>
              <span style="word-break: break-word"> {{ data.item }} </span>
            </v-tooltip>
            <a-chip
              v-else
              small
              outlined
              label
              class="tagChip"
              color="secondary darken-4"
              :key="JSON.stringify(data.item)"
              v-bind="data.item.attrs"
              :close="createTagPermission"
              @click:close="
                createTagPermission ? data.parent.selectItem(data.item) : ''
              "
            >
              <strong>#</strong> {{ data.item }}
            </a-chip>
          </template>
        </v-combobox>
        <div class="d-flex align-center justify-space-between" v-if="createTagPermission">
          <span :style="!createTagPermission ? 'visibility: hidden' : 'opacity: 1'">{{ $t("agenda.msgTagGuide") }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-if="createTagPermission"
                small
                v-on="on"
                v-bind="attrs"
                color="primaryDark"
                @click.stop="onSaveTags"
                :disabled="disableSave || !isDirty"
              >
                {{ $t("btnSave") }}
              </a-btn>
            </template>
            <span> {{ $t("btnSave") }} </span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { TITLE_LENGTH_150 } from "@/utils/constant";
import _ from "lodash";
export default {
  props: {
    topic: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    currentMeeting: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      render: 0,
      isMenuOpen: false,
      tagMenu: false,
      tagsArray: [],
      isTooltipDisabled: false,
      disableSave: false,
      searchInput: '',
      isSearching: false,
      apiSuggestions: [],
      previouslyUsedTags: [],
    };
  },
  mounted() {
    this.tagsArray = this.topic?.tags || [];
    this.$root.$on("refresh-tag", (topic) => {
      if (this.topic?.Id === topic?.Id) {
        this.tagsArray = topic?.tags || [];
      }
    });
  },
  
  beforeDestroy() {
    this.$root.$off("refresh-tag");
    // Cancel any pending debounced searches
    if (this.debouncedSearch && this.debouncedSearch.cancel) {
      this.debouncedSearch.cancel();
    }
  },
  
  watch: {
    isMenuOpen(val) {
      this.isTooltipDisabled = val;
      // Reset search inputs when menu closes
      if (!val) {
        this.searchInput = '';
        this.apiSuggestions = [];
        this.previouslyUsedTags = [];
        this.isSearching = false;
      }
    }
  },
  computed: {
    ...gettersMap(),
    isDirty() {
      return (
        JSON.stringify(this.tagsArray) !== JSON.stringify(this.topic?.tags)
      );
    },
    createTagPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "CreateTag"
        );
      }
      return false;
    },
    
    filteredPreviouslyUsedTags() {
  // Safety check for undefined values
  if (!this.tagsArray || !Array.isArray(this.tagsArray)) {
    return [];
  }
  
  const currentTags = this.tagsArray.map(tag => tag.toLowerCase());
  const searchTerm = (this.searchInput || '').toLowerCase().trim();
  
  // Safety check for previouslyUsedTags
  if (!this.previouslyUsedTags || !Array.isArray(this.previouslyUsedTags)) {
    return [];
  }
  
  // Only show previously used tags if there's no search input
  // This prevents them from showing when input is cleared
  if (!searchTerm) {
    return [];
  }
  
  return this.previouslyUsedTags.filter(tag => {
    const lowerTag = tag.toLowerCase();
    const matchesSearch = lowerTag.includes(searchTerm);
    const notAlreadySelected = !currentTags.includes(lowerTag);
    
    return matchesSearch && notAlreadySelected;
  });
},

    
    filteredApiSuggestions() {
      if (!this.apiSuggestions || !Array.isArray(this.apiSuggestions)) {
        return [];
      }
      
      const currentTags = (this.tagsArray || []).map(tag => tag.toLowerCase());
      
      return this.apiSuggestions.filter(tag => {
        const lowerTag = tag.toLowerCase();
        return !currentTags.includes(lowerTag);
      });
    },
    
    combinedSuggestions() {
      // Combine API suggestions with previously used tags
      // Prioritize API suggestions first, then add previously used tags
      const apiTags = this.filteredApiSuggestions;
      const previousTags = this.filteredPreviouslyUsedTags;
      
      // Remove duplicates between API and previous tags
      const apiTagsLower = apiTags.map(tag => tag.toLowerCase());
      const uniquePreviousTags = previousTags.filter(tag => 
        !apiTagsLower.includes(tag.toLowerCase())
      );
      
      // Combine and limit results
      const combined = [...apiTags, ...uniquePreviousTags];
      return combined.slice(0, 10);
    },
  },
  
  created() {
    // Create debounced search function
    this.debouncedSearch = _.debounce(this.searchTagsFromAPI, 300);
  },
  
  methods: {
    ...mapActions({
      saveTags: "meeting/saveTags",
      searchTags: "meeting/searchTags",
    }),
    onComboboxFocus() {
      // Clear suggestions when focusing if there's no search input
      if (!this.searchInput || !this.searchInput.trim()) {
        this.apiSuggestions = [];
        this.previouslyUsedTags = [];
      }
    },
    onComboboxBlur() {
      // Clear search input and suggestions when losing focus
      setTimeout(() => {
        if (!this.searchInput || !this.searchInput.trim()) {
          this.searchInput = '';
          this.apiSuggestions = [];
          this.previouslyUsedTags = [];
        }
      }, 200); // Small delay to allow for click selections
    },

    async searchTagsFromAPI(searchTerm) {
      if (!searchTerm || !searchTerm.trim() || !this.getMeetingTypeId) {
        this.apiSuggestions = [];
        this.isSearching = false;
        return;
      }
      
      this.isSearching = true;
      
      try {
        const result = await this.searchTags({
          tag: searchTerm.trim(),
          meetingTypeId: this.getMeetingTypeId
        })
        
        if (result.status) {
          this.previouslyUsedTags = result.data || [];
        } else {
          this.previouslyUsedTags = [];
        }
      } catch (error) {
        console.error('Error searching tags:', error);
        this.previouslyUsedTags = [];
      } finally {
        this.isSearching = false;
      }
    },
    
    selectSuggestion(suggestion) {
      if (!this.tagsArray.includes(suggestion)) {
        this.tagsArray = [...this.tagsArray, suggestion];
        // Clear search input after selection
        this.searchInput = '';
        this.apiSuggestions = []; // Clear API suggestions
        this.disableSave = false;
        
        this.$nextTick(() => {
          // Focus back to the input for better UX
          const comboboxRef = this.$refs[`comboTagRef_${this.topic.agendaId}_${this.topic.Id}`];
          if (comboboxRef && comboboxRef.focus) {
            setTimeout(() => {
              comboboxRef.focus();
            }, 100);
          }
        });
      }
    },

    onSearchInputUpdate(value) {
      this.searchInput = value || '';
      this.disableSave = Boolean(value && value.trim());
      
      // If input is cleared, immediately clear suggestions
      if (!value || !value.trim()) {
        if (this.debouncedSearch && this.debouncedSearch.cancel) {
          this.debouncedSearch.cancel();
        }
        this.apiSuggestions = [];
        this.previouslyUsedTags = [];
        this.isSearching = false;
        return;
      }
      
      // Trigger API search when user types
      if (value && value.trim().length > 0) {
        this.debouncedSearch(value.trim());
      }
    },


    onChangeTags(e) {
      // Process the tags properly
      let validTags = [];
      if (Array.isArray(e)) {
        e.forEach((i) => {
          if (typeof i === 'string' && i.trim().length) {
            let tag = i.trim().startsWith("#")
              ? i.trim().substring(1).trim()
              : i.trim();
            if (tag.trim().length) {
              validTags.push(tag.trim());
            }
          }
        });
      }
      
      this.tagsArray = this.validateTags(validTags);
      this.disableSave = this.noChanges();
      
      // Clear search input after tag is processed
      if (!this.searchInput || this.searchInput.trim() === '') {
        this.searchInput = '';
        this.apiSuggestions = [];
      }
    },

    // Keep other methods as they are...
    enforceMaxLength(e) {
      try {
        const input = this.$refs[`comboTagRef_${this.topic.agendaId}_${this.topic.Id}`].$refs.input;
        if (input && input.value.length >= TITLE_LENGTH_150 && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
          e.preventDefault(); // prevent typing beyond maxlength characters
        }
      } catch (error) {
        console.log(error);
      }
      
    },
    noChanges() {
      const arr1 = this.tagsArray || [];
      const arr2 = this.topic?.tags || [];
      arr1.sort();
      arr2.sort();
      return JSON.stringify(arr1) === JSON.stringify(arr2);
    },

    validateTags(arr) {
      return arr
        .filter(
          (tag, index) => arr.indexOf(tag) === index && /^\S*$/.test(tag.trim())
        )
        .map((i) => i.trim());
    },
    onChangeTags(e) {
      if (_.isEqual(e, this.tagsArray)) {
        let validTags = [];
        this.tagsArray.forEach((i) => {
          if (i.trim().length && i.trim().length <= TITLE_LENGTH_150) {
            let tag = i.trim().startsWith("#")
              ? i.trim().substring(1).trim()
              : i.trim();
            if (tag.trim().length) {
              validTags.push(tag.trim());
            }
          }
        });
        this.tagsArray = this.validateTags(validTags);
        this.render++;
        this.disableSave = this.noChanges();
      }
    },
    onSaveTags() {
      const payload = {
        meeting_id: this.currentMeeting.id,
        topic_id: this.topic.Id,
        meetingName: this.currentMeeting.meetingName,
        tags: this.tagsArray,
      };
      this.saveTags(payload)
        .then((res) => {
          res.data.topics.forEach((i) => {
            if (this.topic.Id === i.Id) {
              this.tagsArray = i.tags;
              this.topic.tags = i.tags;
              this.$emit("topicWithSavedTag", i);
            }
          });
          if (res.status !== "failed") {
            this.$emit("saveTagMsg", true);
          }
          this.render++;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
function gettersMap() {
  return mapGetters({
    getMeetingTypeId: "meeting/getMeetingTypeId",
  });
}
</script>
    
<style scoped>
.tag-combobox /deep/ .v-input__slot,
.tag-combobox /deep/ .v-select__selections {
  max-height: 35px;
}
.tag-combobox /deep/ .v-label {
  line-height: 19px;
}
.tag-combobox /deep/ .v-input__control,
.tag-combobox /deep/ .v-input__slot {
  max-height: 110px !important;
}
.tag-combobox /deep/ .v-input__slot {
  margin-bottom: 0 !important;
}
.tag-combobox.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  /deep/
  .v-input__slot {
  box-shadow: none;
  background: var(--v-Neutral-base) !important;
  padding: 0 0 0 12px !important;
}
.tag-combobox /deep/ .v-select__selections {
  max-height: 100px !important;
}
::v-deep .v-input--is-disabled {
  opacity: 0.7 !important;
  pointer-events: none !important;
  cursor: default !important;
}
.tag-combobox /deep/ .v-select__slot {
  max-height: 110px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.tag-combobox /deep/ .v-input__append-inner,
.tag-combobox /deep/ .v-text-field__details {
  display: none !important;
}
.tag-combobox /deep/ input {
  line-height: 21px !important;
}
.tagChip {
  font-size: 13px;
}

/* Additional styles for suggestions */
.tag-combobox /deep/ .v-list-item:hover {
  background-color: #f5f5f5 !important;
}
.tag-combobox /deep/ .v-list-item {
  cursor: pointer;
}
.cursor-pointer {
  cursor: pointer !important;
}
</style>